export default "__VITE_ASSET__DQ_bMV61__"